export type ContractI4hPlanSummary = {
  id?: number | null;
  planCatalogId?: number | null;
  status?: string | null;
  allowedForHolder?: boolean | null;
  allowedForDependent?: boolean | null;
};

export function shouldDisplayContractI4hPlan(plan: ContractI4hPlanSummary) {
  return plan.status === "active" && (Boolean(plan.allowedForHolder) || Boolean(plan.allowedForDependent));
}

export function getVisibleContractI4hPlans<T extends ContractI4hPlanSummary>(plans: T[] | null | undefined) {
  return (plans ?? []).filter(shouldDisplayContractI4hPlan);
}

export function getEditableContractI4hPlanCatalog<T extends { id?: number | null }>(
  catalog: T[] | null | undefined,
  selectedPlans: Array<{ planCatalogId: number }> | null | undefined,
  options?: { contractId?: number | null; showFullCatalog?: boolean },
) {
  const resolvedCatalog = catalog ?? [];
  const resolvedSelectedPlans = selectedPlans ?? [];

  if (!options?.contractId || options.showFullCatalog || resolvedSelectedPlans.length === 0) {
    return resolvedCatalog;
  }

  const selectedIds = new Set(resolvedSelectedPlans.map((item) => item.planCatalogId));
  return resolvedCatalog.filter((plan) => selectedIds.has(Number(plan.id)));
}
